module.exports = __webpack_public_path__ + "img/S__70279436.83ab4906.jpg";